export default __webpack_public_path__ + "static/media/vouchers_desk_roi.af0a400f.png";